export default {"src":"/_next/static/media/yams.1c24ca5d.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};